document.addEventListener("apz:added", () => {
  window.SLIDECART_OPEN();
  window.SLIDECART_UPDATE();
});

function debounce(func, delay) {
  let timerId;

  return function (...args) {
    clearTimeout(timerId);

    timerId = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
}

const getWidgetID = () => {
  if (!window["pz-recommendations"]) {
    return null;
  }
  const APZWidgetContainer = document.querySelector(
    ".slidecarthq div[data-personalization-id]"
  );
  return APZWidgetContainer?.dataset?.personalizationId;
};

const initialRecommendation = () => {
  const timer = setInterval(() => {
    if (!window["pz-recommendations"]) {
      return;
    }
    const WidgetID = getWidgetID();
    if (WidgetID) {
      window["pz-recommendations"].remove(WidgetID);
      window["pz-recommendations"].initialRecommendation(WidgetID);
    }
    clearInterval(timer);
  }, 500);
};

const observeSlidecarthq = () => {
  const targetElement = document.querySelector(".slidecarthq");
  let isEmpty = Boolean(targetElement.querySelector(".empty"));

  const callback = debounce((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === "childList") {
        const emptyElement = targetElement.querySelector(".empty");

        if (isEmpty && !emptyElement) {
          // empty 子元素从存在的状态变为不存在时触发的逻辑
          // 在这里执行你的回调函数
          isEmpty = false;
          initialRecommendation();
        } else if (emptyElement) {
          isEmpty = true;
        }
      }
    }
  }, 300);

  const observer = new MutationObserver(callback);

  observer.observe(targetElement, {
    childList: true,
  });
};

const observeTimer = setInterval(() => {
  const targetElement = document.querySelector(".slidecarthq");
  if (!targetElement) {
    return;
  }
  observeSlidecarthq();
  clearInterval(observeTimer);
}, 1000);

initialRecommendation();
